export const courses=[
    {
        id:1,
        title: "Html/Css/Js",
        price : 700,
        duration: "1 month",
        description:"intro to web development : html/css/java script",
        isAdded : false,
    },
    {
        id:2,
        title: "Python",
        price : 1000,
        duration: "3 months",
        description:"python programming for beginners",
        isAdded : false,
    },
    {
        id:3,
        title: "React",
        price : 900,
        duration: "3 months",
        description:"learning front-end development with react js",
        isAdded : false,
    }
]